const api = "https://instagram-clone-j2zp.onrender.com/api"

export default api
